import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import breakpoints from '../../styles/settings/breakpoints';

const Video = ({ slice }) => {
    return (
        <SVideo>
            <ReactPlayer url={slice.url} light playing controls />
        </SVideo>
    );
};

const SVideo = styled.div`
    * + &,
    & + * {
        margin-top: 60px !important;
    }

    & + & {
        margin-top: 20px;
    }
`;

Video.propTypes = {
    slice: PropTypes.object.isRequired
};

export default Video;
